import React from 'react';

import { useForm } from 'react-hook-form';
import { JRCInputText } from 'components/Form/Input/JRCInputText/JRCInputText';

export const ColorInput = ({ initialValue, onChange }: { initialValue: string; onChange: (color: string) => void }) => {
    const { control, watch, setValue } = useForm({
        defaultValues: { text: initialValue ?? '' },
        criteriaMode: 'all',
    });

    React.useEffect(() => {
        setValue('text', initialValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue]);

    React.useEffect(() => {
        const subscription = watch((data: any) => {
            onChange(data.text);
        });
        return () => subscription.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch, onChange]);

    return <JRCInputText name={'text'} control={control} placeholder={initialValue}></JRCInputText>;
};
